"use client";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useCallback, useState, Suspense } from "react";
import { zustandStore } from "../zustand-store";

const TawkMessengerReact = dynamic(
  () => import("@tawk.to/tawk-messenger-react"),
  {
    ssr: false,
    loading: () => null, // Prevent layout shift while loading
  },
);

// Inner component that handles the Tawk widget logic
function TawkWidget() {
  const pathname = usePathname();
  const { data } = zustandStore();
  const { isProcessingProgressVisible } = data;
  const tawkMessengerRef = useRef<any>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const shouldHideChatWidget =
    pathname.startsWith("/dashboard/edit") ||
    pathname.startsWith("/dashboard/report-builder") ||
    pathname.startsWith("/dashboard/form-builder") ||
    isProcessingProgressVisible;

  const updateWidgetVisibility = useCallback(() => {
    if (tawkMessengerRef.current && isLoaded) {
      if (shouldHideChatWidget) {
        tawkMessengerRef?.current?.hideWidget();
      } else {
        tawkMessengerRef?.current?.showWidget();
      }
    }
  }, [shouldHideChatWidget, isLoaded]);

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    updateWidgetVisibility();
  }, [
    pathname,
    shouldHideChatWidget,
    isProcessingProgressVisible,
    updateWidgetVisibility,
  ]);

  return (
    <TawkMessengerReact
      propertyId={"67aeec6c825083258e14f7bf"}
      widgetId={"1ik1kn25i"}
      // @ts-expect-error TawkMessengerReact type is missing `ref`.
      ref={tawkMessengerRef}
      onLoad={handleLoad}
      // All event handlers must be defined to prevent "is not a function" errors
      // This is a known issue with @tawk.to/tawk-messenger-react v2.x
      onStatusChange={() => { }}
      onBeforeLoad={() => { }}
      onChatMaximized={() => { }}
      onChatMinimized={() => { }}
      onChatHidden={() => { }}
      onChatStarted={() => { }}
      onChatEnded={() => { }}
      onPrechatSubmit={() => { }}
      onOfflineSubmit={() => { }}
      onChatMessageVisitor={() => { }}
      onChatMessageAgent={() => { }}
      onChatMessageSystem={() => { }}
      onAgentJoinChat={() => { }}
      onAgentLeaveChat={() => { }}
      onChatSatisfaction={() => { }}
      onVisitorNameChanged={() => { }}
      onFileUpload={() => { }}
      onTagsUpdated={() => { }}
      onUnreadCountChanged={() => { }}
    />
  );
}

// Main export wrapped in Suspense to handle dynamic import properly
export default function ChatWidget() {
  return (
    <Suspense fallback={null}>
      <TawkWidget />
    </Suspense>
  );
}
